import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=50be7b38&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=ts"
export * from "./MessageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be7b38",
  null
  
)

export default component.exports